import React, { Fragment, useEffect, useState } from "react";
import "./Organization.css";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input } from "reactstrap";
import branch from "../../assets/images/branch.svg";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { getOrg } from "../../api/orgnizations";
import { decryptData } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { failed } from "../../utils/Tostify";
import { orgActions } from "../../context/reducers/organization";
import Loader from "../../components/Loader/Loader";
import CustomPagination from "../../components/Pagination/CustomPagination";
import organization_icon from "../../assets/images/organization-admin.svg";
import EditOrgModal from "./EditOrgModal";
import EditClinicModal from "./EditClinicModel";
import { getAssignedStaffs } from "../../api/User";
import AssignUser from "./AssignUser";
import AddClinic from "./AddClinic";
import { ITEMS_PER_PAGE } from "../../utils/constants";

function Organization({ direction, ...args }) {
    let token = useSelector(state => state.userReducer.token);
    let organization = useSelector(state => state.orgReducer.orgData);
    const orgList = organization?.items || [];
    let roleId = localStorage.getItem("roleId");
    const roles = useSelector((state) => state?.userReducer?.user?.roles);
    const defaultPermissions = useSelector((state) => state?.userReducer?.user?.defaultRole?.value?.permissions);
    const matchedRole = roles?.find((role) => role.value._id === roleId);
    const permissions = matchedRole?.permissions || defaultPermissions;
    const isReadonly = permissions.find((obj)=> obj?.objectName === "Organizations")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Organizations")?.permission.includes('read');
    const isCreate = permissions?.find((obj)=> obj?.objectName === "Organizations")?.permission.includes('create');
    const isEdit = permissions?.find((obj)=> obj?.objectName === "Organizations")?.permission.includes('edit');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [showClinicModal, setShowClinicModal] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState([]);
    const [dropdowntwo, setDropdowntwo] = useState([]);
    const [expandedOrg, setExpandedOrg] = useState([]);
    const [listType, setListType] = useState(null);
    const [orgData, setOrgData] = useState({});
    const [assignedUserList, setAssignedUserList] = useState([]);
    const [clinicData, setClinicData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [openAddOrg, setOpenAddOrg] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sorting state
    const [search, setSearch] = useState("");
    const toggleDropdown = (id) => {
        setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
    };

    const toggleDropdownTwo = (id) => {
        setDropdowntwo(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
    };
    const [currentPage, setCurrentPage] = useState(1);
    const [searchKey, setSearchKey] = useState("");

    const getOrgList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getOrg({ dispatch, token, page, limit });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                dispatch(orgActions.orgListing(responseData));
                setIsLoading(false);
            }else{
                failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const handleExpand = (id) => {
        setExpandedOrg(prev => prev.includes(id) ? prev.filter(orgId => orgId !== id) : [...prev, id]);
    };

    const handleHospBtn = (orgData) => {
        navigate("/super-admin/clinicslist", { state: { ActiveStep: 2 , orgData: orgData, fromEdit : true, fromListing : true} });
    };

    const handleAddUser = (orgData) => {
        navigate("/super-admin/userslist", { state: { ActiveStep: 3 , orgData: orgData, fromEdit : true} });
    };

    const handleAddUserClinic = (orgData, clinicData) => {
       setShowAssignModal(true);
       setOrgData({...orgData, clinicData});
    };

    const handleEditOrg=(orgData)=>{
        setShowModal(!showModal);
        setOrgData(orgData);
    };

    const handleEditClinic=(clinicData, orgName)=>{
        setShowClinicModal(!showClinicModal);
        setClinicData({...clinicData, orgName});
    };

    const handleAssignUser = (orgData)=>{
        setShowAssignModal(!showAssignModal);
        setListType("org");
        setOrgData(orgData);
    };

    const filteredOrgList = orgList?.filter((org) => {
        const searchLower = searchKey.trim().toLowerCase(); // ✅ Trim whitespace before searching

        // Extract phone number as a string, defaulting to an empty string if not found
        const phoneNumber = String(org.telecom?.find((obj) => obj?.system === "phone")?.value || "");

        return (
            org.name?.toLowerCase().includes(searchLower) || // ✅ Ensure `name` exists
            org?.clinics?.some(clinic => clinic?.name?.toLowerCase()?.includes(searchLower)) ||
            org?.clinics?.some(clinic =>
                clinic?.telecom?.some(contact =>
                    typeof contact?.value === "string" && contact.value.toLowerCase().includes(searchLower) // ✅ Check type before calling `.toLowerCase()`
                )
            ) ||
            org?.clinics?.some(clinic =>
                clinic?.address?.some(addr =>
                    addr.city && addr.state &&
                    (addr.city + "," + addr.state).toLowerCase().includes(searchLower) // ✅ Clinic city,state filter together
                )
            ) ||
            org?.contact?.some(contact =>
                typeof contact?.name === "string" && contact.name.toLowerCase().includes(searchLower) // ✅ Ensure `name` is a string before `.toLowerCase()`
            ) ||
            (org.address?.[0]?.city && org.address?.[0]?.state &&
                (org.address[0].city + "," + org.address[0].state).toLowerCase().includes(searchLower)) ||
            phoneNumber.includes(searchLower) // ✅ Always a string, preventing errors
        );
    });

    const sortedOrgList = [...filteredOrgList]?.sort((a, b) => {
        if (!sortConfig.key) return 0;

        let aValue = a[sortConfig.key] || "";
        let bValue = b[sortConfig.key] || "";

        if (sortConfig.key === "admin") {
            aValue = a.contact?.[0]?.name || "";
            bValue = b.contact?.[0]?.name || "";
        } else if (sortConfig.key === "address") {
            aValue = (a?.address?.[0]?.city + "," + a?.address?.[0]?.state || "").toLowerCase();
            bValue = (b?.address?.[0]?.city + "," + b?.address?.[0]?.state || "").toLowerCase();
        } else {
            aValue = aValue.toString().toLowerCase();
            bValue = bValue.toString().toLowerCase();
        }

        if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    // Apply pagination on the sorted data
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const paginatedOrgList = sortedOrgList.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const getAssignedUserList = async (page = 1, limit = 10, searchKey = "") => {
        let res = "";
        try {
          setIsLoading(true);
          setSearch(searchKey);
          res = await getAssignedStaffs({
            dispatch,
            token,
            page,
            limit,
            searchKey,
            orgId: orgData?._id
          });
          const responseData = decryptData(res?.data);
          if (res?.status === "SUCCESS") {
            setAssignedUserList(responseData);
            setIsLoading(false);
          }
        } catch (error) {
          failed(res?.message);
          setIsLoading(false);
        }
    };

    useEffect(() => {
        if(orgData?._id){
            getAssignedUserList();
        }
      },[orgData?._id]);

    useEffect(() => {
        let timerOut = setTimeout(async () => { // debounce
            getOrgList(1, 10, search);
        }, 1000);
        return () => clearTimeout(timerOut);
    }, [search]);

    return (
        <Fragment>
            {showModal && <EditOrgModal refetch={getOrgList} getUpdatedOrgData={()=>{}} orgData={orgData} setShowModal={() => setShowModal(!showModal)}/>}
            {showClinicModal && <EditClinicModal getUpdatedData={()=> {}} refetch={getOrgList} clinicData={clinicData} setShowClinicModal={() => setShowClinicModal(!showClinicModal)}/>}

            {showAssignModal && <AssignUser orgData={orgData} refetch={getOrgList}
            setShowAssignModal={() => setShowAssignModal(!showAssignModal)}
            from={listType} setUpdatedUserList={()=>{}} assignedUserList={assignedUserList?.items} />}

            {isLoading ? <Loader /> : null}
            <div className="admin_application_container organization_blk p-4 table_listing_color  gap-3">
                <div className="d-flex justify-content-between align-items-center main-header-block header-bg">
                    <div className="left_header d-flex align-items-center">
                        <img src={organization_icon} />
                        <h2 className="home-title">Organizations</h2>
                    </div>
                    <div className="right_header_block d-flex justify-content-between align-items-center flex-wrap">
                        <div className="right_header d-flex align-items-center gap-2">
                            <Form className="form_block" onSubmit={(e) => e.preventDefault()}>
                                <FormGroup className="spacing_three">
                                    <Input
                                        id="exampleSearch"
                                        name="search"
                                        placeholder="Search Organizations"
                                        type="search"
                                        value={searchKey}
                                        onChange={(e) => {
                                            setSearchKey(e.target.value);
                                            setCurrentPage(1); // Reset to first page when search changes
                                        }}
                                    />
                                </FormGroup>
                            </Form>
                            <Dropdown direction={direction} isOpen={openAddOrg} toggle={() => setOpenAddOrg((prev)=>!prev)}>
                                <DropdownToggle caret size="xl" className="column_blk p-0 m-0">
                                    <div className="for_details header-add-icon">
                                        <i className="fa fa-plus" ></i>
                                    </div>
                                </DropdownToggle>
                                <DropdownMenu {...args}>
                                    <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                        <div className="add_hosp" onClick={() => isCreate ? navigate("/super-admin/addOrganization", {state : {fromEdit : false}}) :  isReadonly ? failed("You have only read access") : navigate("/super-admin/addOrganization")}>
                                            Create Organization
                                        </div>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <div className="table_space p-0" style={{width:"100%"}}>
                    <div className="table-wrapper">
                        <table className="scroll-table">
                            <thead>
                                <tr className="org_table_list">
                                    <th></th>
                                    <th onClick={() => handleSort("name")}>Name <i className='fas fa-sort'></i></th>
                                    {/* <th></th>
                                    <th></th> */}
                                    <th onClick={() => handleSort("admin")}>Primary Contact <i className='fas fa-sort'></i></th>
                                    <th onClick={() => handleSort("createdAt")}>Created Date <i className='fas fa-sort'></i></th>
                                    <th>Status </th>
                                    <th onClick={() => handleSort("address")}>Location <i className='fas fa-sort'></i></th>
                                    <th>Phone</th>
                                    {/* <th>EHR Connection</th> */}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody className="scrollable-tbody" key={orgData?._id}>
                            {paginatedOrgList?.length > 0 ? paginatedOrgList?.map((orgData, index) => (
<>
                                    <tr>
                                        <td colSpan={9} height={5} className="bg_light" ></td>
                                    </tr>
                                    <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                        <td className="check_in" onClick={() => handleExpand(orgData?._id)}><i className={expandedOrg.includes(orgData?._id) ? 'fas fa-caret-down' : 'fas fa-caret-right'}></i></td>
                                        <td>
                                            <Link
                                                to="/super-admin/orgViewDetail"
                                                className="title_name"
                                                state={{orgData}}
                                            >
                                                <h6>{orgData?.name}</h6>
                                            </Link>
                                       <div className="d-flex gap-3 align-items-center"> <div className='user_table_blk'><i className="fa fa-user"></i>{orgData?.totalUserCount}</div>
                                        <div className="d-flex align-items-center gap-1">
                                                <img src={branch} alt="img_profile" />{orgData?.clinics[0]?.name !==undefined ? orgData.clinics?.length : 0}
                                            </div></div></td>
                                        <td>{orgData?.contact?.[0]?.name}</td>
                                        <td>{moment(orgData?.createdAt).format("MMM-DD-YYYY")}</td>
                                        <td><div className={orgData?.active === true ? "active_block_btn" : "not_active_btn"}>{orgData?.active === true ? "Active" : "Not Active"}</div></td>
                                        <td>{orgData?.address?.[0]?.city + "," + orgData?.address?.[0]?.state}</td>
                                        <td>{orgData?.telecom?.find((obj) => obj?.system === "phone")?.value ?  "+" + orgData?.telecom?.find((obj) => obj?.system === "phone")?.value : "--"}</td>
                                        {/* <td></td> */}
                                        <td>
                                            <Dropdown isOpen={dropdownOpen.includes(orgData?._id)} toggle={() => isEdit ? toggleDropdown(orgData?._id) : isReadonly ? failed("You have only read access") : toggleDropdown(orgData?._id)} direction={direction}>
                                                <DropdownToggle caret size="xl" className="column_blk">
                                                    <div className="for_details">
                                                        <i className="fa fa-ellipsis-v"></i>
                                                    </div>
                                                </DropdownToggle>
                                                <DropdownMenu {...args}>
                                                    {orgData?.active === true ? <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => {navigate("/super-admin/orgViewDetail", {state : {orgData}});localStorage.setItem("addHospital",true);}}>
                                                        <div className="add_hosp">Add Hospital</div>
                                                    </DropdownItem> : null}
                                                     {orgData?.active === true ? <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => {navigate("/super-admin/orgViewDetail", {state : {orgData}});localStorage.setItem("addAssignUser",true);}}>
                                                        <div className="add_hosp" >Add User</div>
                                                    </DropdownItem> : null}
                                                    <DropdownItem className="d-flex gap-2 drop_block_content align-items-center"  onClick={()=> {navigate("/super-admin/orgViewDetail", {state : {orgData}}); sessionStorage.setItem("breadCrumpEntityId", orgData?._id);}}>
                                                        <div className="add_hosp">View Details</div>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                    {expandedOrg.includes(orgData?._id) && orgData?.clinics?.length > 0 && orgData?.clinics[0]?.name !==undefined ? orgData?.clinics?.map((clinic) => (
                                        <tr className="onclick_data" key={clinic?._id}>
                                            {clinic?.active === true ? <td className="check_in"></td> : <td className="check_in"></td>}
                                            <td>
                                            <Link
                                                to="/super-admin/clinicDetail"
                                                className="title_name"
                                                state={{
                                                clinicData: { ...clinic, orgName: orgData?.name, partOf: orgData?._id },
                                                orgDetails: orgData
                                                }}
                                            >
                                                <h6>{clinic?.name}</h6>
                                            </Link>
                                            <div className='user_table_blk'><i className="fa fa-user"></i>{clinic?.userCount}</div>
                                            </td>
                                            <td>{clinic?.contact?.[0]?.name}</td>
                                            <td>{moment(clinic?.createdAt).format("MMM-DD-YYYY")}</td>
                                            <td><div className={clinic?.active === true ? "active_block_btn" : "not_active_btn"}>{clinic?.active === true ? "Active" : "Not Active"}</div></td>
                                            <td>{clinic?.address?.[0]?.city + "," + clinic?.address?.[0]?.state}</td>
                                            <td>{clinic?.telecom?.find((obj) => obj?.system === "phone")?.value ?  "+" + clinic?.telecom?.find((obj) => obj?.system === "phone")?.value : "--"}</td>
                                            <td>
                                                <Dropdown isOpen={dropdowntwo.includes(clinic?._id)} toggle={() => isEdit ? toggleDropdownTwo(clinic?._id) : toggleDropdownTwo(clinic?._id)} direction={direction}>
                                                    <DropdownToggle caret size="xl" className="column_blk">
                                                        <div className="for_details">
                                                            <i className="fa fa-ellipsis-v"></i>
                                                        </div>
                                                    </DropdownToggle>
                                                    <DropdownMenu {...args}>
                                                        {clinic?.active === true ? <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> {handleAddUserClinic(orgData, clinic); setListType("clinic");}}>
                                                            <button className="add_hosp">Add User</button>
                                                        </DropdownItem> : null}
                                                        <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> navigate("/super-admin/clinicDetail", {state : {clinicData: {...clinic, orgName: orgData?.name, partOf: orgData?._id}, orgDetails:orgData}})}>
                                                            <button className="add_hosp">View Details</button>
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </td>
                                    </tr>)) : null}
                                    </>
                            )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
                               </tbody>
                        </table>
                    </div>
                    <CustomPagination
                        totalPages={Math.ceil(filteredOrgList.length / ITEMS_PER_PAGE)}
                        totalRows={filteredOrgList.length}
                        rowsPerPage={ITEMS_PER_PAGE}
                        page={currentPage}
                        handlePage={setCurrentPage}
                    />
                </div>
            </div>
        </Fragment>
    );
}

export default Organization;
